import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    fieldId: String,
    fieldValue: String,
    required: { type: Boolean, default: true },
  };

  connect() {
    this.element.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    // Set hidden field value if configured
    if (this.hasFieldIdValue && this.hasFieldValueValue) {
      const form = this.element.closest("form");
      const field = form?.querySelector(`#${this.fieldIdValue}`);
      if (field) {
        field.value = this.fieldValueValue;
      }
    }

    if (!this.requiredValue) {
      const form = this.element.closest("form");
      if (form) {
        form.querySelectorAll("input, select, textarea").forEach((input) => {
          input.removeAttribute("required");
        });
      }
      return;
    }

    // Handle spinner animation
    const spinnerElement = event.currentTarget.querySelector("[name='spinner']");

    if (spinnerElement) {
      const icon = event.currentTarget.querySelector("svg");

      icon?.classList.toggle("hidden");
      spinnerElement.classList.toggle("hidden");
    }
  }
}
